import { useDraggable } from '@dnd-kit/core';
import {
  Heading,
  Heading2,
  Type,
  Image,
  MousePointerClick,
  Minus,
  FileText,
  AppWindow,
} from 'lucide-react';

interface BlockTypeConfig {
  type: string;
  label: string;
  icon: React.ElementType;
}

const BLOCK_TYPES: BlockTypeConfig[] = [
  { type: 'header', label: 'Cabeçalho', icon: Heading },
  { type: 'subtitle', label: 'Subtítulo (H2)', icon: Heading2 },
  { type: 'text', label: 'Texto', icon: Type },
  { type: 'window', label: 'Janela retrô', icon: AppWindow },
  { type: 'image', label: 'Imagem', icon: Image },
  { type: 'cta', label: 'Botão CTA', icon: MousePointerClick },
  { type: 'divider', label: 'Divisor', icon: Minus },
  { type: 'footer', label: 'Rodapé', icon: FileText },
];

const AVAILABLE_VARIABLES = [
  { variable: '{{nome}}', label: 'Nome' },
  { variable: '{{empresa}}', label: 'Empresa' },
  { variable: '{{plano}}', label: 'Plano' },
  { variable: '{{email}}', label: 'E-mail' },
];

function DraggableBlockType({ type, label, icon: Icon }: BlockTypeConfig) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `palette-${type}`,
    data: { type, fromPalette: true },
  });

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      className={`flex items-center gap-2 p-2 rounded-lg border border-gray-200 bg-white cursor-grab hover:border-blue-400 hover:bg-blue-50 transition-colors select-none ${
        isDragging ? 'opacity-50 shadow-lg' : ''
      }`}
    >
      <Icon className="w-4 h-4 text-gray-500 flex-shrink-0" />
      <span className="text-xs font-medium text-gray-700">{label}</span>
    </div>
  );
}

export function BlockPalette() {
  return (
    <div className="flex flex-col gap-4 h-full overflow-y-auto">
      <div>
        <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 px-1">
          Blocos
        </h3>
        <div className="flex flex-col gap-1.5">
          {BLOCK_TYPES.map((block) => (
            <DraggableBlockType key={block.type} {...block} />
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2 px-1">
          Variáveis
        </h3>
        <div className="flex flex-col gap-1">
          {AVAILABLE_VARIABLES.map(({ variable, label }) => (
            <div
              key={variable}
              className="flex items-center justify-between px-2 py-1.5 rounded-md bg-gray-50 border border-gray-100"
            >
              <span className="text-xs text-gray-500">{label}</span>
              <code className="text-xs font-mono text-blue-600 bg-blue-50 px-1 rounded">
                {variable}
              </code>
            </div>
          ))}
        </div>
        <p className="text-xs text-gray-400 mt-2 px-1">Copie e cole nos campos de texto.</p>
      </div>
    </div>
  );
}

export default BlockPalette;
